export default "__VITE_ASSET__D8s3fTgW__"